module.exports = __webpack_public_path__ + "img/7-2-kolizia.0254bebe.jpg";